import { Box } from "@mui/material";
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
import { useEffect, useRef, useState } from "react";
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
mapboxgl.accessToken = 'pk.eyJ1IjoibWFwaXRhcHAiLCJhIjoiY2tvN2s0bzh0MXduajJ4bHBkOHhkdncwMyJ9.dYrI7DfoQuXfyIofEsifbQ';
if (mapboxgl.getRTLTextPluginStatus() === 'unavailable')
    mapboxgl.setRTLTextPlugin(
    'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
    null,
    true
);
export default function MapAddressCard({
    coordinates,
    handleChange,
    readOnlyMap = false,
    ...props
}) {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [isMapListenerCreated, setMapListenerCreated] = useState(false);
    const [marker, setMarker] = useState(new mapboxgl.Marker());

    const setMarkerLngLat = lngLat => {
        marker.setLngLat(lngLat)
        if (!coordinates?.length) {
            marker.addTo(map.current);
        }
        setMarker(marker);
        handleChange({ target: { name: "coordinates", value: [lngLat.lng, lngLat.lat] } })
    }

    useEffect(() => {
        try {
            if (map.current) return;
            map.current = new mapboxgl.Map({
                container: mapContainer.current,
                style: 'mapbox://styles/mapbox/streets-v11',
                center: [46.663077, 24.727627],
                zoom: 9
            });

            if (!readOnlyMap) {
                const geocoder = new MapboxGeocoder({
                    accessToken: mapboxgl.accessToken,
                    mapboxgl: mapboxgl,
                    marker: false
                });

                geocoder.on('result', function (e) {
                    const coordinates = e.result?.geometry?.coordinates
                    setMarkerLngLat({ lng: coordinates[0], lat: coordinates[1] })
                });

                map.current.addControl(geocoder);
            }

            map.current.addControl(new mapboxgl.NavigationControl());
            map.current.addControl(new mapboxgl.GeolocateControl());
        } catch (error) {
            console.log('error')
            console.log(error)
        }
    });

    useEffect(() => {
        try {
            if (isMapListenerCreated || !map.current) return;
            if (!readOnlyMap) {
                map.current.on('click', e => setMarkerLngLat(e.lngLat));
            }
            setMapListenerCreated(true);
        } catch (error) {
            console.log('error')
            console.log(error)
        }
    });
    useEffect(() => {
        if (!!coordinates && coordinates.length) {
            marker.setLngLat(coordinates)
            marker.addTo(map.current);
            setMarker(marker);
            map.current.setCenter(coordinates)
        } else {
            // Remove marker from map if coordinates are empty
            marker.remove();
        }
    }, [coordinates])
    return (
        <Box ref={mapContainer} {...props} />
    )
}